// src/services/postUploadGuard.js
//
// GÖNDERI DENETIMI P1 — "hayalet post" fix'inin parçası.
//
// NewPost yüklemesi sürerken appModals backdrop'u modalı kapatabiliyordu;
// upload + addDoc arka planda devam edip kullanıcı "iptal oldu" sanırken
// post sessizce yayınlanıyordu. Backdrop kapatması bu bayrağa bakar:
// yükleme sürerken backdrop tıklaması modal'ı KAPATMAZ (kullanıcı Geri/
// Paylaş butonlarını zaten göremezken kazara kaybetmesin).
//
// Modül-seviyesi tek bayrak yeterli: aynı anda tek NewPost modal'ı var.

let uploading = false;

// `Boolean(v)` ile normalize ediliyor → girdi bilerek serbest.
export function setPostUploading(v: unknown) {
  uploading = Boolean(v);
}

export function isPostUploading() {
  return uploading;
}
